(function () {
  'use strict';

  const bar = document.querySelector('[data-pdp-ship]');
  if (!bar) return;

  const textEl = bar.querySelector('[data-pdp-ship-text]');
  const fillEl = bar.querySelector('[data-pdp-ship-fill]');
  if (!textEl || !fillEl) return;

  // EUR cart.total_price is in subunits (cents = euros × 100).
  const MONEY_FACTOR = 100;

  // Format a subunit amount as EUR, mirroring the cart drawer's formatMoney:
  // 2 decimals, comma decimal separator, non-breaking space, " €".
  function formatEur(subunits) {
    return ((Number(subunits) || 0) / MONEY_FACTOR).toFixed(2).replace('.', ',') + ' €';
  }

  // Single source of truth: the cart drawer root carries a live cart total
  // (kept fresh by custom-cart-drawer.js after each add-to-cart) and the
  // free-shipping threshold. Both are in cents.
  const cartRoot = document.getElementById('TpCartDrawerRoot');

  const progressTemplate = bar.getAttribute('data-progress') || '';
  const unlockedText = bar.getAttribute('data-unlocked') || '';
  const fallbackThreshold = (parseInt(bar.getAttribute('data-threshold-fallback'), 10) || 0) * MONEY_FACTOR;

  function getThreshold() {
    const fromRoot = cartRoot ? parseInt(cartRoot.getAttribute('data-threshold'), 10) : 0;
    return fromRoot || fallbackThreshold;
  }

  function getTotal() {
    return cartRoot ? parseInt(cartRoot.getAttribute('data-cart-total'), 10) || 0 : 0;
  }

  function update() {
    const total = getTotal();
    const threshold = getThreshold();
    const isUnlocked = threshold > 0 && total >= threshold;

    bar.classList.toggle('is-unlocked', isUnlocked);

    if (isUnlocked) {
      textEl.textContent = unlockedText;
      fillEl.style.width = '100%';
    } else {
      textEl.textContent = progressTemplate.replace('[amount]', formatEur(threshold - total));
      const pct = threshold > 0 ? Math.max(0, Math.min(100, (total / threshold) * 100)) : 0;
      fillEl.style.width = pct + '%';
    }
  }

  // Re-paint whenever the cart drawer updates its total/threshold (e.g. after
  // an add-to-cart on this page). No edits to the cart drawer JS required.
  if (cartRoot && 'MutationObserver' in window) {
    new MutationObserver(update).observe(cartRoot, {
      attributes: true,
      attributeFilter: ['data-cart-total', 'data-threshold'],
    });
  }

  update();
})();
